module.exports = __webpack_public_path__ + "img/growth.43e55e10.svg";